import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { BehaviorSubject, Observable, of } from 'rxjs';

import { UserModel } from '../models/user.model';
import { TokenAdminService } from '../token/token-admin.service';

@Injectable({ providedIn: 'root' })
export class AdminUserService {
  private userSubject = new BehaviorSubject<any>(null);
  public companySubject = new BehaviorSubject<any>(null);
  public tokenPermissionSubject = new BehaviorSubject<any>(null);
  jwtHelper = new JwtHelperService();

  constructor(private tokenService: TokenAdminService) {
    // tslint:disable-next-line: no-unused-expression
    this.tokenService.hasToken() && this.decodeAndNotify();
  }

  setToken(token: string) {
    this.tokenService.setToken(token);
    this.decodeAndNotify();
  }

  setCompany(company: any) {
    this.companySubject.next(company);
  }

  getUser() {
    return this.userSubject.asObservable();
  }

  notify(user: UserModel) {
    this.userSubject.next(user);
  }

  private decodeAndNotify() {
    try {
      const token = this.jwtHelper.decodeToken(
        this.tokenService.getToken() as string
      );
      const user = JSON.parse(token.user);
      // console.log(user);
      this.userSubject.next(user);
    } catch (error) {
      this.logout();
    }
  }

  logout() {
    this.tokenService.removeToken();
    this.userSubject.next(null);
  }

  isLogged() {
    return this.tokenService.hasToken();
  }

  getCurrentUser() {
    return this.userSubject.value;
  }

  getUserRoles(): Observable<any> {
    const user = this.userSubject.value;

    if (user) {
      return of(user.roles);
    }

    return of([]);
  }

  isTokenExpired() {
    if (this.tokenService.hasToken()) {
      const token = this.tokenService.getToken();
      const isExpired = this.jwtHelper.isTokenExpired(token);

      return isExpired;
    }

    return false;
  }
}
